export class DiaryUpdateEvent {}
